<script lang="ts">
	import { page } from '$app/stores';
	import { fade } from 'svelte/transition';

	$: currentPage = $page.url.pathname;

	const pages = [
		{ title: 'Pedidos', href: '/pedidos' },
		{ title: 'Inventario', href: '/inventario' },
		{ title: 'Categorías', href: '/administrar-categorias' }
	];
</script>

<nav transition:fade|local class="w-max">
	<ul class="flex flex-row space-x-4">
		{#each pages as { href, title }}
			<li class={currentPage === href ? 'underline' : ''}><a {href}>{title}</a></li>
		{/each}
	</ul>
</nav>
